<div class="panel__refresh medium-spinner active-spinner">
  <span class="spin-circle"></span>
</div>